import React, { Component } from 'react';
import _ from 'lodash';

const columns = 5;

class GridItem extends Component {
  constructor(props) {
    super(props);
    this.image = React.createRef();
    this.onImageLoad = this.onImageLoad.bind(this);
  }

  onImageLoad() {
    const { setRatio, id } = this.props;
    const gridItem = this.image.current;
    const height = gridItem.offsetHeight;
    const width = gridItem.offsetWidth;

    setRatio && setRatio(id, width, height);
  }

  getGridDimensions() {

    const { setRatio, id } = this.props;
    const gridItem = this.image.current;
    if (!gridItem) {
      return {
        count: 0,
        width: 0,
        height: 0,
      }
    }
    const height = gridItem.offsetHeight;
    const width = gridItem.offsetWidth;
    const gridWidth = width / columns;

    return {
      count: Math.ceil(height / gridWidth) * columns,
      width: gridWidth,
      height: gridWidth,
    }
  }

  componentDidUpdate(newProps) {

    if (this.props.styles !== newProps.styles) {
      this.forceUpdate();
    }
  }

  shouldComponentUpdate() {
    return true;
  }

  render() {
    const {
      url,
      style,
      show,
      id,
      rating,
      showGrid = false,
      left,
      top,
      onClickGridLine,
      zoomed,
    } = this.props;

    const {
      count,
      height,
      width,
    } = this.getGridDimensions();

    const zoom = 3;
    const gridStyles = {
      transform: `scale(${zoom}) `
    }

    return (
      <div
        key={id}
        className={`grid-item ${!show ? 'hidden' : null} ${id}`}
        style={{
          ...style,
          borderColor: zoomed ? 'transparent' : '#ccc'
        }}
      >
        <div className="grid-lines-container" style={zoomed ? gridStyles : {}}>
          {
            showGrid && _.times(count, i => (
              <div
                className="grid-lines"
                style={{ height, minWidth: width, width }}
                onClick={() => !zoomed ? onClickGridLine({
                  left: (i % columns) * width,
                  top: (Math.floor(i/10) + 1) * height,
                  zoomed: true
                }) : onClickGridLine({
                  zoomed: false
                }) }
              ></div>
            ))
          }
        </div>
        <img
          key={id}
          ref={this.image}
          src={url}
          onLoad={this.onImageLoad}
          style={zoomed ? gridStyles : {}}
        />
        <p>{rating}</p>
      </div>
    )
  }
}

export default GridItem;


// WEBPACK FOOTER //
// ./src/components/GridItem.js